import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    crudDeleteMany,
    translate,
    showNotification
} from 'react-admin';
import { startUndoable as startUndoableAction } from 'ra-core';
import MaterialUiButton from '@material-ui/core/Button';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button'
import compose from 'recompose/compose';

const sanitizeRestProps = ({
    basePath,
    resource,
    selectedIds,
    startUndoable,
    undoable,
    dispatchCrudDeleteMany,
    ...rest
}) => rest;

const styles = {
    button: { marginRight: '1em', marginLeft: '1em' },
};

class BulkDeleteButton extends Component {
    static propTypes = {
        basePath: PropTypes.string,
        resource: PropTypes.string.isRequired,
        startUndoable: PropTypes.func,
        selectedIds: PropTypes.arrayOf(PropTypes.any).isRequired,
        undoable: PropTypes.bool,
        dispatchCrudDeleteMany: PropTypes.func.isRequired,
        dialogGuidance: PropTypes.string,
    };
    state = {
        showDialog: false
    };

    static defaultProps = {
        undoable: true,
    };

    handleClick = () => {
        this.setState({ showDialog: true });
    }

    handleCloseClick = () => {
        this.setState({ showDialog: false });
    };

    handleSubmit = () => {
        const {
            startUndoable,
            resource,
            selectedIds,
            basePath,
            undoable,
            dispatchCrudDeleteMany
        } = this.props;
        if (undoable) {
            startUndoable(crudDeleteMany(resource, selectedIds, basePath));
        } else {
            dispatchCrudDeleteMany(resource, selectedIds, basePath);
        }
        this.setState({ showDialog: false });
    }

    render() {
        const { showDialog } = this.state;
        const { onClick, translate, dialogGuidance, ...rest } = this.props;
        return (
            <MuiThemeProvider>
                <Fragment>
                    <MaterialUiButton
                        variant="outlined"
                        onClick={this.handleClick}
                        style={styles.button}
                        color='secondary'
                        {...sanitizeRestProps(rest) }>{translate("common.bulkDelete")}
                    </MaterialUiButton>
                    <Dialog
                        fullWidth
                        open={showDialog}
                        onClose={this.handleCloseClick}
                    >
                        <DialogContent>
                            <DialogContentText>
                                <p>
                                    {translate(dialogGuidance)}
                                </p>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                variant='raised'
                                onClick={this.handleSubmit}
                                color="primary">
                                {translate("ra.action.delete")}
                            </Button>
                            <Button
                                onClick={this.handleCloseClick}>
                                {translate("ra.action.cancel")}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Fragment>
            </MuiThemeProvider>                       
        );
    }
}

BulkDeleteButton.propTypes = {
    crudDeleteMany: PropTypes.func,
    startUndoable: PropTypes.func,
    record: PropTypes.object,
};

const enhance = compose(
    translate,
    connect(
        undefined,
        { crudDeleteMany, showNotification, startUndoable: startUndoableAction  }
    )
);

export default enhance(BulkDeleteButton);